/**
 * Firebase initialization and main service
 * 
 * SETUP INSTRUCTIONS:
 * 1. Install: npm install firebase ✅ DONE
 * 2. Enable Authentication in Firebase Console
 * 3. Enable Firestore Database in Firebase Console
 * 4. Set up security rules (see firebase-setup.md)
 */

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics, isSupported } from "firebase/analytics";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBY7kl5HhPW3S8uoHB_C85T3wQ073CtRmE",
  authDomain: "mindbridge-6a057.firebaseapp.com",
  projectId: "mindbridge-6a057",
  storageBucket: "mindbridge-6a057.firebasestorage.app",
  messagingSenderId: "307240930296",
  appId: "1:307240930296:web:370249e789bc886734e40d",
  measurementId: "G-Q2YL0BE0JQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export let analytics = null;

if (typeof window !== "undefined") {
  isSupported().then((supported) => {
    if (supported) analytics = getAnalytics(app);
  });
}

export const initializeFirebase = () => {
  // Firebase initialized successfully
  return { app, auth, db, analytics };
};
